export default __webpack_public_path__ + "static/swim-6400639487cd41514cfe1e566dd98e48.jpg";